export class InviteEmailMismatch extends Error {
  public constructor() {
    super()

    this.message = 'invitePage.inviteErrors.emailMismatch'
  }
}
